'use client';
import Image from 'next/image';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
// Replace with your actual SVG or leave as placeholder
export const SparkScanLogo = ({ className }: { className?: string }) => {
  const { resolvedTheme } = useTheme();
  const [logoSrc, setLogoSrc] = useState<string>('/logo-dark.svg');

  useEffect(() => {
    setLogoSrc(resolvedTheme === 'dark' ? '/logo-light.svg' : '/logo-dark.svg');
  }, [resolvedTheme]);

  return (
    <Image
      src={logoSrc}
      alt="Sparkscan Logo"
      width={26}
      height={26}
      className={className}
      priority
      suppressHydrationWarning
    />
  );
};
